import { FC } from 'react';
import { Control, useController } from 'react-hook-form';
import styled from 'styled-components';

import Checkbox from '@/components/Checkbox';

import { FormDataT } from './ImportModal';

const Box = styled.div`
  padding: 0 16px;
  height: 46px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  width: 100%;
`;

interface Props {
  control: Control<FormDataT>;
}

const ShouldShuffleField: FC<Props> = ({ control }) => {
  const {
    field: { value, onChange },
  } = useController({ control, name: 'should_shuffle' });

  return (
    <Box>
      <Checkbox checked={value} onChange={() => onChange(!value)}>
        Shuffle posts in the queue after upload
      </Checkbox>
    </Box>
  );
};

export default ShouldShuffleField;
